import { useParams } from 'react-router-dom';
import { HotWheelsForm } from './hotwheels-form';

/**
 * Page wrapper that decides create vs edit based on URL params.
 *
 * /collection/new   → mode='create'
 * /collection/:itemId/edit → mode='edit'
 */
export function HotWheelsFormPage() {
  const { itemId } = useParams<{ itemId: string }>();
  const mode: 'create' | 'edit' = itemId ? 'edit' : 'create';
  return <HotWheelsForm mode={mode} itemId={itemId} />;
}

export default HotWheelsFormPage;